<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style lang="less">
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

#app {
    font-size: 0.16rem;
    font-family: 'Source Han Sans', "Microsoft YaHei", "宋体", "PingFang SC", Helvetica, Arial, Tahoma, serif, sans-serif;
    font-weight: 400;
    color: #333333;
    background-color: #ffffff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

button, input {
    outline: 0!important;
    border: none;
    cursor: pointer;
}

select {
    outline: 0!important;
}

ul {
    list-style: none;
}

input:focus {
    outline: 0;
}

input {
    border: none;
}

table {
    border-collapse: collapse;
}

input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    font-size: 0.14rem;
    color: #c4c7cf;
}

:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    font-size: 0.14rem;
    color: #c4c7cf;
}

::-moz-placeholder { /* Mozilla Firefox 19+ */
    font-size: 0.14rem;
    color: #c4c7cf;
}

input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    font-size: 0.14rem;
    color: #c4c7cf;
}

input::-ms-input-placeholder { /* Microsoft Edge */
    font-size: 0.14rem;
    color: #c4c7cf;
}

table {
    border-collapse: collapse;//表格单元格间距样式
}
</style>



// WEBPACK FOOTER //
// src/App.vue